import { render, staticRenderFns } from "./Startseite DESKA.vue?vue&type=template&id=ebc2790c&"
import script from "./Startseite DESKA.vue?vue&type=script&lang=js&"
export * from "./Startseite DESKA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports